<div
  class="flex max-h-[calc(100dvh-8rem)] min-h-0 flex-col overflow-hidden lg:h-[calc(100vh-12rem)] lg:max-h-[74vh] lg:min-h-[380px] lg:pr-0"
>
  <!-- Grid de dos columnas -->
  <div
    class="grid flex-1 grid-cols-1 content-start gap-4 overflow-y-auto overflow-x-hidden pr-1 lg:min-h-0 lg:grid-cols-2 lg:gap-6 lg:overflow-hidden lg:pr-0"
  >
    <!-- Columna Izquierda: Productos Seleccionados -->
    <div class="flex flex-col lg:min-h-0">
      <h3 class="mb-4 text-lg font-bold text-slate-900">Productos Seleccionados</h3>

      <div
        class="mb-4 max-h-none space-y-3 overflow-visible pr-0 lg:min-h-0 lg:flex-1 lg:overflow-y-auto lg:overflow-x-hidden lg:pr-1"
      >
        <!-- Producto seleccionado 1 -->
        @for (producto of productos_seleccionados(); track producto.id) {
          <div class="rounded-lg border border-slate-200 bg-white p-3 sm:p-4">
            <div class="mb-3 flex items-start gap-2">
              <div class="flex-1 min-w-0">
                <div class="mb-1 flex items-start justify-between gap-3">
                  <h4 class="font-semibold text-slate-900 text-sm">{{ producto.nombre }}</h4>
                  <button
                    class="text-red-500 hover:text-red-700 transition"
                    (click)="quitarProductoSeleccionado(producto)"
                    aria-label="Quitar producto"
                  >
                    <i class="bi bi-trash text-sm"></i>
                  </button>
                </div>
                <p class="text-xs text-slate-600 mb-2">
                  {{ producto.precio | currency: 'PEN' : 'S/. ' }}
                </p>

                <!-- Control de cantidad y precio -->
                <div
                  class="mb-2 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-[auto_auto_1fr] xl:items-center"
                >
                  <!-- Cantidad -->
                  <div class="flex flex-wrap items-center gap-2 sm:flex-nowrap">
                    <span class="min-w-10 text-xs text-slate-600">Cant.</span>
                    <button
                      class="w-9 h-9 sm:w-7 sm:h-7 rounded flex items-center justify-center transition"
                      [ngClass]="{
                        'bg-slate-200 hover:bg-slate-300 cursor-not-allowed':
                          producto.cantidad <= 1,
                        'bg-blue-600 hover:bg-blue-700': producto.cantidad > 1,
                      }"
                      [disabled]="producto.cantidad === 1"
                      (click)="btnCantidad(producto, 'disminuir')"
                      aria-label="Disminuir cantidad"
                    >
                      <i
                        class="bi bi-dash text-sm"
                        [ngClass]="{
                          'text-slate-500': producto.cantidad <= 1,
                          'text-white': producto.cantidad > 1,
                        }"
                      ></i>
                    </button>
                    <app-input-number
                      [(value)]="producto.cantidad"
                      inputId="cantidad"
                      [min]="1"
                      [max]="producto.controlar_stock ? producto.stock : undefined"
                      styleClass="min-w-0"
                    />
                    <button
                      class="w-9 h-9 sm:w-7 sm:h-7 rounded flex items-center justify-center transition"
                      [ngClass]="{
                        'bg-blue-600 hover:bg-blue-700':
                          producto.cantidad < producto.stock || producto.controlar_stock == false,
                        'bg-slate-200 cursor-not-allowed':
                          producto.cantidad >= producto.stock && producto.controlar_stock == true,
                      }"
                      [disabled]="
                        producto.controlar_stock === true && producto.cantidad >= producto.stock
                      "
                      (click)="btnCantidad(producto, 'aumentar')"
                      aria-label="Aumentar cantidad"
                    >
                      <i
                        class="bi bi-plus text-sm"
                        [ngClass]="{
                          'text-slate-500':
                            producto.cantidad >= producto.stock && producto.controlar_stock == true,
                          'text-white':
                            producto.cantidad < producto.stock || producto.controlar_stock == false,
                        }"
                      ></i>
                    </button>
                  </div>

                  <!-- Precio -->
                  <div class="flex flex-wrap items-center gap-2 sm:flex-nowrap">
                    <span class="min-w-10 text-xs text-slate-600">Precio</span>
                    <app-input-number
                      [(value)]="producto.precio"
                      inputId="precio"
                      [min]="0"
                      styleClass="min-w-0 shrink"
                    />
                  </div>
                </div>

                <!-- Descripción/Notas -->
                <app-textarea
                  [value]="producto.nota || ''"
                  (valueChange)="producto.nota = $event"
                  class="w-full max-w-full"
                  [maxLength]="255"
                  rows="2"
                />

                <!-- Subtotal -->
                <div class="mt-1 flex items-center justify-end gap-2 rounded-md bg-slate-50">
                  <span class="text-xs text-slate-600">Subt.</span>
                  <span class="whitespace-nowrap text-sm font-semibold text-slate-900 sm:text-base">
                    {{ producto.precio * producto.cantidad | currency: 'PEN' : 'S/. ' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        } @empty {
          <div
            class="mx-auto flex h-full w-full max-w-md flex-col items-center justify-center py-8 text-center"
          >
            <i class="bi bi-cart-x text-5xl text-slate-300 mb-3"></i>
            <p class="text-slate-500 font-medium">No hay productos seleccionados</p>
            <p class="text-sm text-slate-400">Selecciona productos de la lista</p>
          </div>
        }
      </div>

      <!-- Resumen -->
      <div class="mt-auto hidden border-t border-slate-300 pt-3 lg:block">
        <div class="rounded-lg bg-blue-50 p-3">
          <div class="flex justify-between items-center mb-2">
            <span class="text-sm text-slate-600">Total productos:</span>
            <span class="font-semibold text-slate-900">{{ totalProductosSeleccionados() }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-sm text-slate-600">Total:</span>
            <span class="text-lg font-bold text-blue-600">{{
              totalPrecioProductosSeleccionados() | currency: 'PEN' : 'S/. '
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Columna Derecha: Búsqueda de Productos -->
    <div class="flex flex-col lg:min-h-0">
      <!-- Búsqueda -->
      <div class="mb-4">
        <div class="mb-3 flex items-center justify-between gap-3">
          <h3 class="text-lg font-bold text-slate-900">Buscar Producto</h3>
          <app-button
            icon="bi bi-plus-lg"
            variant="success"
            [rounded]="true"
            styleClass="w-7 h-7 sm:w-6 sm:h-6"
            [appTooltip]="'Agregar producto libre'"
            tooltipPosition="top"
            (onClick)="modal_producto_libre.set(true)"
          />
        </div>
        <app-input-buscador
          #inputBuscador
          id="busqueda"
          placeholder="Buscar producto por nombre o código"
          [(valor)]="busqueda"
          class="flex-1"
          (presionaEnter)="onBuscar()"
        />
      </div>
      <!-- Categorías -->
      <div class="mb-4">
        <div class="flex gap-2 overflow-x-auto pb-2 pr-1">
          <button
            class="px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap"
            [ngClass]="{
              'bg-blue-600 text-white': categoria_seleccionada() === null,
              'bg-slate-100 text-slate-700 hover:bg-slate-200': categoria_seleccionada() !== null,
            }"
            (click)="filtrarPorCategoria(null)"
          >
            Todos
          </button>
          @for (categoria of categorias(); track categoria.id) {
            <button
              class="px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition"
              [ngClass]="{
                'bg-blue-600 text-white': categoria_seleccionada() === categoria.id,
                'bg-slate-100 text-slate-700 hover:bg-slate-200':
                  categoria_seleccionada() !== categoria.id,
              }"
              (click)="filtrarPorCategoria(categoria.id)"
            >
              {{ categoria.nombre }}
            </button>
          }
        </div>
      </div>

      <!-- Lista de productos -->
      <div
        class="space-y-2 overflow-visible pr-0 lg:min-h-0 lg:flex-1 lg:overflow-y-auto lg:overflow-x-hidden lg:pr-1"
      >
        @for (producto of paginacion()?.data ?? []; track producto.id) {
          <div
            class="cursor-pointer rounded-lg border border-slate-200 bg-white p-3 transition hover:border-blue-400 hover:bg-blue-50 hover:shadow-md"
            (click)="agregarProducto(producto)"
          >
            <div class="flex items-center gap-3">
              <div class="flex-1 min-w-0">
                <h4 class="font-semibold text-slate-900 text-sm">{{ producto.nombre }}</h4>
                <p class="text-xs text-slate-600">SKU: {{ producto.codigo }}</p>
                @if (
                  producto.descuento_campana_id != null &&
                  producto.precio_venta_final != null &&
                  producto.precio_venta_original != null
                ) {
                  <div class="mt-1 flex items-center gap-2">
                    <span class="text-xs text-slate-400 line-through">
                      {{ producto.precio_venta_original | currency: 'PEN' : 'S/. ' }}
                    </span>
                    <span class="text-sm text-blue-600 font-semibold">
                      {{ producto.precio_venta_final | currency: 'PEN' : 'S/. ' }}
                    </span>
                  </div>
                } @else {
                  <p class="text-sm text-blue-600 font-semibold mt-1">
                    {{ producto.precio_venta | currency: 'PEN' : 'S/. ' }}
                  </p>
                }
              </div>
              <button
                class="w-10 h-10 sm:w-8 sm:h-8 bg-blue-600 hover:bg-blue-700 rounded-lg flex items-center justify-center transition shrink-0"
                aria-label="Agregar producto"
              >
                <i class="bi bi-plus text-white"></i>
              </button>
            </div>
          </div>
        }
      </div>
      @if (paginacion() != null) {
        <app-paginacion
          [items]="paginacion()!.data"
          [itemsPorPagina]="paginacion()!.size"
          [totalItems]="paginacion()!.total"
          (paginaCambiada)="cambiarPagina($event)"
        />
      }
    </div>
  </div>

  <!-- Botones de Acción -->
  <div
    class="mt-4 shrink-0 flex flex-col gap-3 border-t border-slate-200 pt-4 sm:flex-row sm:gap-4"
  >
    <button
      class="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2 group"
      (click)="confirmarAgregarProductos()"
    >
      <i class="bi bi-check-circle text-lg group-hover:scale-110 transition-transform"></i>
      <span>Agregar Productos</span>
    </button>
    <button
      class="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-700 font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2 group"
      (click)="cancelarAgregarProductos()"
    >
      <i class="bi bi-x-circle text-lg group-hover:scale-110 transition-transform"></i>
      <span>Cancelar</span>
    </button>
  </div>
</div>

<app-dialog
  header="Agregar Producto Libre"
  [modal]="true"
  [(visible)]="modal_producto_libre"
  size="sm"
  styleClass="w-[92vw] max-w-[640px]"
>
  @if (modal_producto_libre() == true) {
    <app-agregar-producto-libre
      (closedModal)="modal_producto_libre.set(false)"
      (agregarProducto)="onAgregarProducto($event)"
    />
  }
</app-dialog>
